
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/devhacker/lh-website-client/sentry.client.config.ts")
            }
          });